module.exports = __webpack_public_path__ + "static/media/most-bonus.cac4dc0c.png";